// extracted by mini-css-extract-plugin
export default {"iconArrowLeft":"IconArrowLeft_iconArrowLeft__uOCXL"};